export enum RoleTrack {
  OPS = 'Ops & Infrastructure',
  PLATFORM = 'Platform Engineering',
  SECURITY = 'Cloud Security',
  ARCHITECTURE = 'Solutions Architecture'
}

export enum EngineerLevel {
  ASSOCIATE = 'Associate',
  CLOUD_ENGINEER = 'Cloud Engineer',
  SENIOR_ENGINEER = 'Senior Engineer',
  PRINCIPAL_ENGINEER = 'Principal Engineer',
  SOLUTIONS_ARCHITECT = 'Solutions Architect',
  SENIOR_ARCHITECT = 'Senior Solutions Architect',
  PRINCIPAL_ARCHITECT = 'Principal Solutions Architect'
}

export interface SkillNode {
  title: string;
  description: string;
  level: EngineerLevel;
  tags: string[];
}

export interface Comparison {
  topic: string;
  junior: string;
  senior: string;
}